import React from 'react';
import { Link } from 'react-router-dom';
import { APP_ROUTES } from '../routes';
import { useAuth } from '../hooks/useAuth';
import { logout } from '../api/auth';

interface ErrorPageProps {
    title?: string;
    message?: string;
    showLogout?: boolean;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
    title = "Something went wrong",
    message = "We're sorry, but an unexpected error occurred. Please try again later.",
    showLogout = false,
}) => {
    const { dispatch } = useAuth();

    const handleLogout = async () => {
        await logout();
        dispatch({ type: 'LOGOUT' });
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center px-4">
            <h1 className="text-4xl font-bold text-red-600 mb-4">{title}</h1>
            <p className="text-lg text-gray-700 mb-8 max-w-md">{message}</p>
            {showLogout ? (
                <button
                    onClick={handleLogout}
                    className="px-6 py-3 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    Logout
                </button>
            ) : (
                <Link
                    to={APP_ROUTES.DASHBOARD}
                    className="px-6 py-3 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    Go to Dashboard
                </Link>
            )}
        </div>
    );
};

export default ErrorPage;
